import React, { useState } from 'react'
import { Box, Drawer, Fade, Icon, Modal, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import { postJobBoardApplicationForm } from 'services/api/job-board'
import { useMutation } from 'react-query'
import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'
import AdxButton from 'components/custom/AdxButton'

const MobileJobBoardApplicationDrawer = () => {
  const params = useParams()
  const job_id = params?.id
  const company_uuid = params?.uuid
  const company_name = params?.companyName

  const schema = yup
    .object()
    .shape({
      resume: yup
        .mixed()
        .test('fileRequired', 'This field is required.', (value) => {
          return value && value.length > 0
        })
        .test('fileType', 'Only PDF files are allowed.', (value) => {
          // Check file type

          if (value.length > 0) {
            const fileType = value[0].type
            return fileType === 'application/pdf'
          } else return false
        })
        .test('fileSize', 'File size must be less than 5MB.', (value) => {
          // Check file size (in bytes)
          if (value.length > 0) {
            const fileSize = value[0].size
            return fileSize <= 5 * 1024 * 1024 // 5MB in bytes
          } else return false
        }),

      firstName: yup.string().required('This field is required.'),
      lastName: yup.string().required('This field is required.'),
      email: yup.string().email().required('This field is required.'),
      phone: yup.number().required(),
    })
    .required()

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  // API calls
  const { mutate: submitJobApplication } = useMutation(
    (value) => postJobBoardApplicationForm(company_uuid, value),
    {
      onSuccess: (res) => {
        console.log(res)
        handleClose()
        handleSuccess()
      },
      onError: (error) => {
        console.log(error)
      },
    }
  )

  const onSubmit = (data) => {
    const submitData = { ...data, resume: data?.resume[0], job_id: job_id }
    submitJobApplication(submitData)
  }

  const [open, setOpen] = useState(false)
  const [successOpen, setSuccessOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const handleSuccess = () => {
    setSuccessOpen(true)
  }

  const handleSuccessClose = () => {
    setSuccessOpen(false)
  }
  //   const handleDrawer
  return (
    <>
      <SuccessModal
        open={successOpen}
        handleClose={handleSuccessClose}
        company_uuid={company_uuid}
        company_name={company_name}
      />
      <AdxButton
        variant={'contained'}
        sx={{ boxShadow: 'none', whiteSpace: 'nowrap', width: '100%' }}
        onClick={() => handleOpen()}
      >
        Apply Now
      </AdxButton>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: '4.5px 4.5px 0px 0px',
          },
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              width: '100%',
              height: 'calc(100vh - 70.66px)',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: '4.5px 4.5px 0px 0px',
              gap: '32px',
              height: '100%',
              padding: '16px',
            }}
          >
            <Box>
              <Typography variant="h2" fontFamily={'Oswald'} sx={{ fontWeight: 600 }}>
                Application Details
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '16px',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'start',
                  width: '100%',
                  gap: '8px',
                }}
              >
                <Typography sx={{ whiteSpace: 'nowrap' }}>
                  Resume / CV (5MB max.)<span style={{ color: 'red' }}>*</span>
                </Typography>
                <AdxInput
                  isErrorShown={errors.resume}
                  errorMessage={
                    <Typography sx={{ color: 'red' }}>{errors.resume?.message}</Typography>
                  }
                  type="file"
                  sx={{ width: '100%' }}
                  sxInput={{ outline: '1px solid #CACACA' }}
                  {...register('resume')}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'start',
                  width: '100%',
                  gap: '8px',
                }}
              >
                <Typography sx={{ whiteSpace: 'nowrap' }}>
                  First name<span style={{ color: 'red' }}>*</span>
                </Typography>
                <AdxInput
                  sx={{ width: '100%' }}
                  sxInput={{ outline: '1px solid #CACACA' }}
                  {...register('firstName')}
                  isErrorShown={errors.firstName}
                  errorMessage={
                    <Typography sx={{ color: 'red' }}>{errors.firstName?.message}</Typography>
                  }
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'start',
                  width: '100%',
                  gap: '8px',
                }}
              >
                <Typography sx={{ whiteSpace: 'nowrap' }}>
                  Last name<span style={{ color: 'red' }}>*</span>
                </Typography>
                <AdxInput
                  sx={{ width: '100%' }}
                  sxInput={{ outline: '1px solid #CACACA' }}
                  {...register('lastName')}
                  isErrorShown={errors.lastName}
                  errorMessage={
                    <Typography sx={{ color: 'red' }}>{errors.lastName?.message}</Typography>
                  }
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'start',
                  width: '100%',
                  gap: '8px',
                }}
              >
                <Typography sx={{ whiteSpace: 'nowrap' }}>
                  Email<span style={{ color: 'red' }}>*</span>
                </Typography>
                <AdxInput
                  type="email"
                  sx={{ width: '100%' }}
                  sxInput={{ outline: '1px solid #CACACA' }}
                  {...register('email')}
                  isErrorShown={errors.email}
                  errorMessage={
                    <Typography sx={{ color: 'red' }}>{errors.email?.message}</Typography>
                  }
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'start',
                  width: '100%',
                  gap: '8px',
                }}
              >
                <Typography sx={{ whiteSpace: 'nowrap' }}>
                  Phone<span style={{ color: 'red' }}>*</span>
                </Typography>
                <Box sx={{ width: '100%' }}>
                  <Controller
                    name="phone"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <>
                        <PhoneInput
                          country={'my'}
                          inputStyle={{
                            height: '45px',
                            width: '100%',
                          }}
                          onChange={onChange}
                        />
                        {errors.phone?.message && (
                          <p className="text-body2 text-error">{errors.phone?.message}</p>
                        )}
                      </>
                    )}
                  />
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'end', gap: '8px' }}>
              <AdxButton
                variant={'ghost'}
                onClick={() => handleClose()}
                type="button"
                sx={{ border: 'none' }}
              >
                Cancel
              </AdxButton>
              <AdxButton variant={'contained'} type="submit" sx={{ boxShadow: 'none' }}>
                Submit Application
              </AdxButton>
            </Box>
          </Box>
        </form>
      </Drawer>
    </>
  )
}

export default MobileJobBoardApplicationDrawer

export const SuccessModal = ({ open, handleClose, company_uuid, company_name }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 343,
    height: 320,
    bgcolor: 'background.paper',
    borderRadius: '4.5px',
    boxShadow: 24,
    padding: '32px',
  }

  const navigate = useNavigate()

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                height: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '20px',
                  width: '100%',
                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: 'default-background.main',
                    borderRadius: '100%',
                    padding: '30px',
                  }}
                >
                  <Icon sx={{ fontSize: '40px', color: 'alternate.main' }}>business_center</Icon>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignContent: 'center',
                    gap: '6px',
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="h4" fontWeight={600}>
                    Application received!
                  </Typography>
                  <Typography sx={{ color: 'light-gray-text.main' }}>
                    Thank you! Your submission is now under review.
                  </Typography>
                </Box>
              </Box>
              <AdxButton
                variant={'outlined'}
                onClick={() => {
                  handleClose()
                  navigate(`/job-board/${company_name}/${company_uuid}`)
                }}
                sx={{ width: '100%' }}
              >
                Close
              </AdxButton>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  )
}
